function is_int(value){
  if((parseFloat(value) == parseInt(value)) && !isNaN(value)){
      return true;
  } else {
      return false;
  }
}

function isNumber(n){
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function valide_date(value) {
  var gooddate = new RegExp("^\[0-9]{2}\/[0-9]{2}\/[0-9]{4}$");
  return gooddate.test(value);
}

function valide_mail(mail){
    var reg = new RegExp('^[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*@[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*[\.]{1}[a-z]{2,6}$', 'i');
    if(reg.test(mail)){
        return(true);
    }
    else{
        return(false);
    }
}

function prix_formate(prix)
  {
  prix = Math.round(prix*100)/100;
  dec = prix - Math.round(prix);
  if(dec==0)
    return prix + '.00';
  else
    {
    dec2 =  Math.round(100*dec)/10
    //alert(dec2);
    dec = dec2 - Math.round(dec2);
    //alert(prix+'->'+dec)
      if(dec==0)
        return prix + '0';
      else
        return prix+'';
    }
  }

function envoi_courriel(str1,str2,str3,str4){
    if(str4)
        return "mailto:"+str1+"@"+str2+"."+str3+"?"+str4;
    else
        return "mailto:"+str1+"@"+str2+"."+str3;
}

function MM_openBrWindow(theURL,winName,features){ //v2.0
  window.open(theURL,winName,features);
}

function getAllUrlParams(url) {

  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      //if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {

        // create key if it doesn't exist
        var key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string'){
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}


function affiche_besoin_facture(){ //v3.0
    if($("#besoin_facture").val() == "oui")
        $("#ligne_choix_adresse_facturation").show();
    else {
        $("#ligne_choix_adresse_facturation").hide();
        $("#ligne_adresse_fact").hide();
    }
}

function affiche_adresse_fact(){ //v3.0
    if($("#choix_adresse_facturation").val() == "d")
        $("#ligne_adresse_fact").show();
    else
        $("#ligne_adresse_fact").hide();
}

function affiche_alerte_paiment(i){ //v3.0
    $(".alerte-paiement").hide();
    $("#alerte-paiement"+i).show();
}

